export default "__VITE_PUBLIC_ASSET__6fffdab9__"